import { Leads } from "../modules/leads"

export const LeadsPage = () => {
  return (
    <Leads/>
  )
}
